import { BrowserNoteDraft, clearBrowserNoteDraft, listUnexpiredBrowserNoteDrafts } from './browserDrafts'

type Importer = (draft: BrowserNoteDraft) => Promise<boolean>

const slotOf = ({ uid, type }: { uid: string; type: string }) => `${uid}:${type}`

let started = false
const pending = new Map<string, Promise<void>>()

export const pendingBrowserNoteDraft = ({ uid, type }: { uid: string; type: string }): Promise<void> | null =>
  pending.get(slotOf({ uid, type })) ?? null

// A key is removed only after the server inserts it.
export const startBrowserNoteDraftMigration = (importDraft: Importer) => {
  if (started || typeof window === 'undefined') {
    return
  }
  started = true

  listUnexpiredBrowserNoteDrafts().forEach((draft) => {
    const task = importDraft(draft)
      .then((imported) => {
        if (imported) {
          clearBrowserNoteDraft(draft.storageKey)
        }
      })
      .catch(() => undefined)
    pending.set(slotOf(draft), task)
  })
}

export const resetBrowserNoteDraftMigrationForTests = () => {
  started = false
  pending.clear()
}
